/* eslint-disable */
// This file does not really work and is not used
import { h, Component, createRef } from "preact";
import { connect } from "react-redux";

import locationsApi from "../api/locations";
import { sendError } from "../errors";
import { getConfig } from "../services/config";
import { selectResult } from "../store";
import BackButton from "./BackButton.jsx";
import Button from "./Button.jsx";

import LocationAddress from "./LocationAddress.jsx";

@connect(null, { selectResult })
export default class LocationFinder extends Component {
  map = null;
  ref = createRef();

  state = {
    locations: [],
    initialized: false,
    selectedLocation: null,
    sending: false,
    err: null,
  };

  handleMarkAsDone = async () => {
    this.setState({ sending: true });
    try {
      selectResult({ task: this.props.task, result: selectedLocation.id });
    } catch (err) {
      sendError(err);
      console.error(err);
    }
    this.setState({ sending: false });
  };

  initMarkers = () => {
    if (!this.state.initialized && this.state.locations.length > 0 && L) {
      this.setState({ initialized: true });
      locations.forEach((location) => {
        var marker = L.marker(location.latLng).addTo(map);
        marker.bindPopup(
          `<b>${location.title}</b><br/><div class="address-line">${location.address}</div>`
        );
        marker.addEventListener("click", () => {
          this.setState({ selectedLocation: location });
        });
      });
    }
  };

  async componentWillMount() {
    locations = await locationsApi.fetchLocations(this.props.locationId);

    this.setState({
      selectedLocation: locations.find(
        (loc) => loc.id === this.props.task.data?.result
      ),
    });
    initMarkers();
  }
  componentDidMount() {
    this.ref.current.querySelector("script").onload = () => {
      map = L.map("mapid").setView([51.505, -0.09], 13);

      L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          id: "mapbox/streets-v11",
          tileSize: 512,
          zoomOffset: -1,
          accessToken: getConfig("mapboxAccessToken"),
        }
      ).addTo(map);
      map.setView(L.latLng(53.5, 10), 10);
      initMarkers();
    };
  }

  render() {
    const { selectedLocation } = this.state;

    return (
      <div class="checklist" ref="this.ref">
        <link
          rel="stylesheet"
          href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css"
          integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A=="
          crossorigin=""
        />
        <script
          src="https://unpkg.com/leaflet@1.7.1/dist/leaflet.js"
          integrity="sha512-XQoYMqMTK8LvdxXYG3nZ448hOEQiglfqkJs1NOQV44cWnUrBc8PkAOcXy20w0vlaXaVUearIOBhiXZ5V3ynxwA=="
          crossorigin=""
        ></script>
        <h4>Search for it here:</h4>
        <div id="mapid" style="height: 500px"></div>
        <h5>Selected:</h5>
        {selectedLocation && <LocationAddress location={selectedLocation} />}
        {this.props.onBack && (
          <BackButton class="mr-2" noIndent onClick={this.props.onBack} />
        )}
        <Button
          href="#"
          disabled={!selectedLocation || sending}
          onClick={(event) => {
            event.preventDefault();
            this.handleMarkAsDone();
          }}
        >
          Choose {selectedLocation ? selectedLocation.title : "this location"}
        </Button>
      </div>
    );
  }
}
